jQuery(document).ready(function ($) {
	$('section.related ul.products').slick({
		slidesToShow: 4,
		slidesToScroll: 4,
		infinite: true,
		responsive: [
			{
				breakpoint: 1210,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3,
				},
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				},
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				},
			},
		],
	}).css({
		'visibility': 'visible',
		'height': 'auto',
	});
});

jQuery(document).ready(function ($) {
	// product-slider equalize heights.
	setTimeout(function () {
		let slider = $('.product-slider');
		let slideTitles = slider.find('.product-slide h3');
		let maxHeight = slideTitles.first().height();
		if ( slider.length > 0 ) {
			//find max height
			slideTitles.each(function () {
				let height = $(this).height();
				if ( height > maxHeight ) {
					maxHeight = height;
				}
			});
			// apply same height to all
			slideTitles.height(maxHeight);
		}
	}, 1);

	// we-are-more-then widget mobile js - legacy SO widget - remove later
	if ( $(window).width() < 767 ) {
		$('.we-are-more-then .text-box.has-child').click(function () {
			$(this).siblings().removeClass('active');
			$(this).toggleClass('active');
		});
	}

	// we-are-more-then block mobile js
	if ( $(window).width() < 767 ) {
		$('.we-are-more-then-block .text-box.has-child').click(function () {
			$(this).siblings().removeClass('active');
			$(this).toggleClass('active');
		});
	}

	// Header search functionality
	let search = $('#top-bar-menu .search-form');
	search.on('focusin', function () {
		search.addClass('is-focused');
	}).on('focusout', function () {
		search.removeClass(' is-focused');
	});

	$('.search-form').find('.search-submit').on('click', function(){

        $(this).parent().append("<div class='vet-spinner vet-spinner--medium vet-spinner--align-left loaded'></div>");
	});

	$('.searchwp-live-search-results').on('focusin', function () {
        search.addClass('is-focused');
    }).on('focusout', function () {
        search.removeClass(' is-focused');
    });

});

jQuery(function ($) {
	$('.news-slider-widget .news-slider').slick({
		dots: true,
	});

	//kolektivs title slider slick
	$('.page-title-slider').slick({
		fade: true,
		infinite: true,
	});
});



jQuery(function ($) {
	// Homepage main menu hover script
	let menu_item = $('.top-bar.is-homepage ul#main-nav li');
	menu_item.each(function () {
		if ( $(this).hasClass('menu-item-has-children') ) {
			let menu_html = $(this).find('a')[0].outerHTML;
			$(this).find('ul.menu').prepend(menu_html).addClass('gradient-side').wrapInner('<div class="inner-wrapper"></div>');
		}
	});

	// Product carousel script
	if ( $('section.product-slider-container').length > 0 ) {
		$('.product-slider').slick({
			slidesToShow: 3,
			slidesToScroll: 3,
			arrows: true,
			responsive: [
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						dots: true,
					},
				},
			],
		});
	}
});

// My account pages
jQuery(function ($) {

	// Mobile navigation on login / registration page
	let mob_menu = $('.wc-login-register .mobile-menu');
	let forms = $('.wc-login-register .u-columns');

	mob_menu.find('span').each(function () {
		$(this).click(function () {
			if ( !$(this).hasClass('active') ) {
				mob_menu.find('span').removeClass('active');
				forms.children('div').removeClass('active');

				$(this).addClass('active');

				let get_class = '.col-' + $(this).attr('data-id');
				forms.children(get_class).addClass('active');
			}
		});
	});
});

jQuery(document).ready(function ($) {
	$('.woocommerce-view-order .order-items__info').on('mouseenter', function () {
		$(this).find('.tooltip').removeClass('hide');
	}).on('mouseleave', function () {
		$(this).find('.tooltip').addClass('hide');
	});


	// Contactform in contacts ty pop-up
	$('.job-time-contact-form').on('wpcf7mailsent', function () {
		$('#contactform-ty-pop-up').addClass('show');
	});

	$('#contactform-ty-pop-up').click(function (e) {

		if ( e.target === $(this).get(0) || e.target === $(this).find('.close').get(0) || e.target === $(this).find('.pop-up-close-button').get(0) ) {
			$(this).removeClass('show');
		}
	});
});

